<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :selection="selection" :col-span="colSpan" :get-action="queryApi" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @afterFetchOriginalData="afterFetchOriginalData" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.customer.name')" prop="companyName">
            <BjInput v-model="queryParams.companyName" :placeholder="$t('AccountManagement.customer.name')" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('DetailsOfThirdPartySalesOrder.employee')" prop="sales">
            <BjSelectLov v-model="queryParams.sales" :option-list="csgSalesList" :placeholder="$t('DetailsOfThirdPartySalesOrder.employee')" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <!--  1.Request Submitted(申请提交)  2.Docs Approved（文件审批） 3.Finance Setup（财务审批） 4.Account Created（ERP账号创建） -->
        <!--  5.Checklist Upload（清单上传） 6.ERP Training（ERP 培训）  7.IT Solution（IT实施）     8.Final Check（最终确认） -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.Stage')" prop="processStatus">
            <BjSelectLov v-model="queryParams.processStatus" :placeholder="$t('CustomerFunction.Stage')" multiple :option-list="USER_ONBOARDING_STAGE_LIST" />
          </el-form-item>
        </el-col>
      </template>

      <template v-slot:tableOperation>
        <el-col>
          <el-button v-permission:USER-ONBOARDING-ADD type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
        </el-col>
      </template>

      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'industry'">
                <el-tag>{{ $t(USER_ONBOARDING_INDUSTRY_LIST.bjGet(scope.row[col.prop])) }}</el-tag>
              </template>
              <template v-else-if="col.prop === 'processStatus'">
                <el-tag>{{ $t(USER_ONBOARDING_STAGE_LIST.bjGet(scope.row[col.prop])) }}</el-tag>
              </template>
              <template v-else-if="col.prop === 'estWeeklyRevenue'">
                <span v-if="scope.row[col.prop] || scope.row[col.prop]==0">{{ $number2money(scope.row[col.prop]) }}</span>
                <span v-else>{{ scope.row[col.prop] }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
              <el-button type="text" class="edit-btn" @click="onAudit(props.row)">{{ $t('table.auditText') }}</el-button>
              <el-button v-permission:USER-ONBOARDING-ADD type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
              <el-button v-permission:USER-ONBOARDING-ADD type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh"/>
    <!-- 新增/编辑弹窗 -->
    <AuditForm ref="AuditForm" @reFresh="reFresh"/>
  </div>
</template>

<script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { USER_ONBOARDING_STAGE_LIST,USER_ONBOARDING_INDUSTRY_LIST } from '@/utils/constants';
  import { funConfigApi,userApi } from '@/api';
  import DataForm from './DataForm.vue';
  import AuditForm from './AuditForm.vue';

  export default {
    name: 'onboardingPageIndex',
    components: {DataForm,AuditForm},
    mixins: [pageMiXin],
    data() {
      return {
        colSpan: 4,
        selection: true,
        USER_ONBOARDING_STAGE_LIST,
        USER_ONBOARDING_INDUSTRY_LIST,
        queryApi: funConfigApi.getOnboardingList,
        queryParams: {
          companyName: null,
          sales: null,
          processStatus: ["request", "docs", "finance", "account", "checklist", "erp", "it", "final"],
        },
        labelList: [
          { label: this.$t('AccountManagement.customer.name'), prop: 'companyName', isCheck: true, disabled: false, },
          { label: this.$t('AccountManagement.table.createTime'), prop: 'creationDate', isCheck: true, disabled: false, },
          { label: this.$t('DetailsOfThirdPartySalesOrder.employee'), prop: 'sales', isCheck: true, disabled: false, },
          { label: this.$t('toolsProfit.industry'), prop: 'industry', isCheck: true, disabled: false },
          { label: this.$t('CustomerFunction.Stage'), prop: 'processStatus', isCheck: true, disabled: false },
          { label: this.$t('CustomerFunction.CurrentApprover'), prop: 'approver', isCheck: true, disabled: false },
          { label: this.$t('CustomerFunction.PalletText'), prop: 'estimationPalletQty', isCheck: true, disabled: false },
          { label: this.$t('CustomerFunction.WeeklySalesText'), prop: 'estWeeklyRevenue', isCheck: true, disabled: false, width: 113 },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 200 },
        ],
        customerNameList: [],
        csgSalesList: [],
      };
    },
    created(){
      // 获取客服下拉数据
      this.getCustomerList()
    },
    methods: {
      // 获取客服下拉数据
      getCustomerList(){
        userApi.getUserList({enabled: true,customerType: 'P',deptAbbr:'Customer Service'}).then(res=>{
          if(res.content.length){
            // 获取客服下拉数据
            this.customerNameList = res.content.map(item => {
              return { label: item.realName, value: item.realName, customerServiceId: item.id};
            });
            // 获取销售下拉数据
            userApi.getUserList({enabled: true,customerType: 'P',deptAbbr:'Sales'}).then(resp=>{
              if(resp.content.length){
                this.csgSalesList = resp.content.map(item => {
                  return { label: item.realName, value: item.realName };
                });
              }
            })
          }
        })
      },

      /** 新增入场客户 */
      onAdd() {
        this.$refs.DataForm.openType = 'add'
        this.$refs.DataForm.customerNameList = this.customerNameList;
        this.$refs.DataForm.show();
      },

      /** 查看入场客户 */ 
      onView(row) {
        this.$refs.DataForm.openType = 'view'
        this.$refs.DataForm.show(row);
      },

      /** 审核入场客户 */ 
      onAudit(row) {
        this.$refs.AuditForm.openType = 'audit'
        this.$refs.AuditForm.show(row);
      },

      /** 编辑入场客户 */ 
      onEdit(row) {
        this.$refs.DataForm.openType = 'edit'
        this.$refs.DataForm.customerNameList = this.customerNameList;
        this.$refs.DataForm.show(row);
      },

      // 删除入场客户
      onDelete(row) {
        this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            funConfigApi.delOnboardingList({onboardingId:row.id}).then(res => {
              if (!res.failed) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 500);
              }
            });
          })
          .catch(() => {});
      },

      beforeResetSearch() {
        this.queryParams.companyName = null;
        this.queryParams.sales = null;
        this.queryParams.processStatus = ["request", "docs", "finance", "account", "checklist", "erp", "it", "final"];
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label {
  display: none;
}
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
</style>
